import { Add } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import { useState } from 'react'

import { RepairOrderExpanded } from '../../../sdk'
import {
  CreateDiscountDialogProps,
  CreateDiscountDialogUI
} from '../Discount/CreateDiscountDialogUI'

export const AddDiscountButton = ({
  repairOrder
}: {
  repairOrder: RepairOrderExpanded
}) => {
  const [createDiscountDialogProps, setCreateDiscountDialogProps] =
    useState<CreateDiscountDialogProps>()

  return (
    <>
      {createDiscountDialogProps && (
        <CreateDiscountDialogUI
          {...createDiscountDialogProps}
          setCustomProps={setCreateDiscountDialogProps}
        />
      )}
      {repairOrder.entry?.info?.discount ? (
        <Typography variant="subtitle2" color="primary">
          Discount Applied
        </Typography>
      ) : (
        <Button
          size="small"
          onClick={(event) => {
            event.stopPropagation()
            setCreateDiscountDialogProps({
              repairOrderEntry: repairOrder.entry!
            })
          }}
          startIcon={<Add />}
          disabled={!!repairOrder.entry?.info?.discount}>
          Discount
        </Button>
      )}
    </>
  )
}
